
<form (keydown.enter)="$event.preventDefault()" (ngSubmit)="onSubmit()" [formGroup]="certForm">
    <div class="two-col-grid">
        <div id="form-wrapper">
            <ng-container *ngIf="state.user.serviceTypes | keyvalue as serviceTypes">
                <div *ngIf="serviceTypes.length > 0">
                    <h3>Tegund viðbragðsaðila</h3>

                    <mat-form-field class="short">
                        <mat-label>Viðbragðsaðili</mat-label>
                        <mat-select formControlName="serviceTypeId" required>
                            <mat-option *ngFor="let val of serviceTypes" [value]="+val.key">{{val.value}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </ng-container>
            <div>
                <h3>Aðgangshópur</h3>

                <mat-form-field class="short">
                    <mat-select formControlName="accessGroupId" required>
                        <mat-option *ngFor="let val of accessGroups" [value]="val.id">{{val.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div>
                <h3>Ábyrgðaraðili</h3>

                <mat-form-field class="short">
                    <mat-label>Kennitala</mat-label>
                    <input matInput formControlName="certificateRecipientSsn" required>
                </mat-form-field>
                <p *ngIf="(ssnNameLookup$ | async) as nafn">
                    <i>{{nafn}}</i>
                </p>
            </div>

            <div>
                <h3 *ngIf="accessGroup">Skilríki</h3>
                <mat-form-field class="short" *ngIf="accessGroup?.conditionallyRequiredFields && accessGroup?.conditionallyRequiredFields.length > 0">
                    <mat-label>Skilríki fyrir</mat-label>
                    <mat-select formControlName="accessType">
                        <mat-option *ngFor="let opt of accessGroup.conditionallyRequiredFields" [value]="opt">
                            {{certAccessFields[opt]}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div *ngIf="certForm.get('accessType')?.value as conditionallyRequiredField">
                    <ng-container *ngTemplateOutlet="accessField;context:{field: conditionallyRequiredField, fieldRequired: true}"></ng-container>
                </div>

                <div *ngFor="let reqField of (accessGroup?.requiredFields || [])">
                    <ng-container *ngTemplateOutlet="accessField;context:{field: reqField, fieldRequired: true}"></ng-container>
                </div>

                <div *ngFor="let optField of (accessGroup?.optionalFields || [])">
                    <ng-container *ngTemplateOutlet="accessField;context:{field: optField, fieldRequired: false}"></ng-container>
                </div>

                <ng-template #accessField let-field="field" let-fieldRequired="fieldRequired">
                    <ng-container [ngSwitch]="field">
                        <ng-container *ngSwitchCase="'vehicleCallsign'">
                            <ng-container *ngTemplateOutlet="vehicleCallsignControl;context:{isRequired: fieldRequired}"></ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'phoneNumber'">
                            <ng-container *ngTemplateOutlet="phoneNumberControl;context:{isRequired: fieldRequired}"></ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'stationId'">
                            <ng-container *ngTemplateOutlet="stationIdControl;context:{isRequired: fieldRequired}"></ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'districtId'">
                            <ng-container *ngTemplateOutlet="districtIdControl;context:{isRequired: fieldRequired}"></ng-container>
                        </ng-container>
                    </ng-container>
                </ng-template>
                
                <ng-template #vehicleCallsignControl let-isRequired="isRequired">
                    <mat-form-field class="short">
                        <mat-label>Kallmerki bíls</mat-label>
                        <input matInput formControlName="vehicleCallsign" [required]="isRequired" [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let option of vehicleAutocomplete$ | async" [value]="option">{{option}}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-template>

                <ng-template #phoneNumberControl let-isRequired="isRequired">
                    <mat-form-field class="short">
                        <mat-label>Símanúmer</mat-label>
                        <input matInput formControlName="phoneNumber" [required]="isRequired">
                    </mat-form-field>
                </ng-template>

                <ng-template #stationIdControl let-isRequired="isRequired">
                    <mat-form-field class="short">
                        <mat-label>Stöð</mat-label>
                        <mat-select [required]="isRequired" formControlName="stationId">
                            <mat-option *ngFor="let val of stations | keyvalue" [value]="+val.key">{{val.value}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-template>

                <ng-template #districtIdControl let-isRequired="isRequired">
                    <mat-form-field class="short">
                        <mat-label>Embætti</mat-label>
                        <mat-select [required]="isRequired" formControlName="districtId">
                            <mat-option *ngFor="let val of districts | keyvalue" [value]="+val.key">{{val.value}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-template>

            </div>

            <div></div>
            <div>
                <div>
                    <button mat-raised-button type="submit">Skrá {{code.length > 0 ? 'annað' : ''}}</button>
                </div>
            </div>
        </div>
        <div id="copy-code-section">
            <p>
                Aðeins ábyrgðaraðilinn getur opnað hlekkinn og virkjað skilríkið.
            </p>
            <ng-container *ngIf="code">
                <div id="code-field">
                    <input #urlCopy (click)="urlCopy.select()" [value]="baseUrl + '/?key=' + code" readonly>
                </div>
                <button mat-raised-button color="primary" (click)="copyUrl()" type="button">Afrita</button>
                <p>Afritið hlekkinn og sendið á ábyrgðaraðilann, sem getur þá skráð sig inn og sótt skilríkið.</p>
            </ng-container>
        </div>
    </div>
</form>

